export default `
## Markdown
Je kunt hier tekst opmaken met [Markdown](http://commonmark.org/help/).

### Link
\`\`\`
Dit is [een link](www.example.com).
\`\`\`

### Opmaak
\`\`\`
## Tussenkop

_Schuingedrukt_

**Dikgedrukt**
\`\`\`

### Lijst
\`\`\`
1. Genummerde
2. Lijst

* Ongenummerde
* Lijst
\`\`\`

### Afbeelding
\`\`\`
![Omschrijving afbeelding](https://example.com/plaatje.jpg)
\`\`\`
`;
